import React from 'react';
import { LensOrderField, OrderDirection } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';


export type LensesValidSortFields = LensOrderField.NAME;

export const LensesDefaultDirections: DefaultDirections<LensesValidSortFields> = {
  [LensOrderField.NAME]: OrderDirection.ASC,
};

export const LensDefaultSortField = LensOrderField.NAME;

export function LensesGridSortProvider(
  props: Pick<SortProviderProps<LensesValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<LensesValidSortFields>
      validOrderFieldsWithDefaultDirections={LensesDefaultDirections}
      defaultField={LensDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
